<template>
  <div id="mySidenav" class="sidenav">
    <div style="display: flex; align-items: center; justify-content: space-between; background: #f1f1f1; height: 4em;">
      <strong style="margin-left: 1em;">{{ title }}</strong>
      <a style="margin-right: 1em;" href="javascript:void(0)" class="closebtn" v-on:click="closeNav()">
        <font-awesome-icon icon="chevron-left" style="font-size: 2em;"></font-awesome-icon>
      </a>
    </div>

    <!-- Botones de pestañas (Mobile) -->
    <div class="btn-container tab-container" v-show="isMobile && mode != 4">
      <button class="btn btn-secondary btn-tab" v-on:click="mode = 0; resetAllSelectedButtons()"
        :class="{ btnTabSelected: mode == 0 }">
        <font-awesome-icon icon="arrow-left" v-if="mode != 0"></font-awesome-icon>
        <font-awesome-icon icon="toolbox" v-else></font-awesome-icon>
      </button>
      <!-- Otros botones comentados por ahora -->
    </div>

    <!-- Herramientas (Mode 0) -->
    <div v-show="mode == 0" class="tools">
      <!-- Botones de herramientas -->
      <button v-for="item in menuData" :key="item.id" class="btn btn-secondary" v-on:click="onClickSelectTool(item.id)">
        <font-awesome-layers class="fa-lg">
          <font-awesome-icon :icon="item.icon" />
        </font-awesome-layers>
        <p>{{ item.label }}</p>
      </button>

      <button class="btn btn-secondary" v-on:click="onClickGoHome()">
        <font-awesome-layers class="fa-lg">
          <font-awesome-icon icon="times" />
        </font-awesome-layers>
        <p>Salir del Mapa</p>
      </button>
    </div>

  </div>
</template>

<script>

import { vuex } from '@/components/mixin/vuex.js'

export default {
  name: 'NavDrawer',
  mixins: [vuex],
  components: {
    // Layers,
    // Charts,
    // Search,
    // Legends,
    // Annotations,
    // Select
  },
  data() {
    return {
      mode: 0,
      lastMode: 0,
      menuData: [
        {
          "id": "select",
          "icon": "hand-pointer",
          "label": "Consulta" //Se cambia nombre de herramienta segun observacion de SENAPRED 06/2026 ("Le herramienta no es de selección, sino de consulta, por lo que debería llamarse "Consulta"")
        },
        {
          "id": "layers",
          "icon": "layer-group",
          "label": "Capas"
        },
        {
          "id": "legends",
          "icon": "list-alt",
          "label": "Simbología"
        },
        {
          "id": "shpKmzUpload",
          "icon": "file-import",
          "label": "Desplegar SHP/KMZ"
        },
        {
          "id": "search",
          "icon": "search",
          "label": "Buscador"
        },
        {
          "id": "locator",
          "icon": "location-arrow", //icono actualizado a "location-arrow" segun observacion de SENAPRED 06/2026 ("1. Herramienta de localizador sin símbolo")
          "label": "Localizador"
        },
        {
          "id": "annotations",
          "icon": "comment",
          "label": "Anotaciones"
        },
        {
          "id": "basemap",
          "icon": "map",
          label: "Mapas Base" //nombre actualizado segun observacion de SENAPRED 06/2026 ('La herramienta deberia llamarse "Mapas Base"')
        },
        {
          "id": "geoprocessing",
          "icon": "cogs",
          "label": "Geoproceso"
        },
        {
          "id": "draw",
          "icon": "pen",
          "label": "Dibujar"
        },
        {
          "id": "measures",
          "icon": "ruler-combined",
          "label": "Medir mapa"
        },
        {
          "id": "help",
          "icon": "question",
          "label": "Ayuda"
        }
      ]
    }
  },
  computed: {
    title: function () {
      switch (this.mode) {
        case 0: return 'Herramientas'
        case 1: return 'Lista de capas'
        case 2: return 'Gráficos'
        case 3: return 'Buscador'
        case 4: return 'Simbología'
        case 5: return 'Selección'
        default: return 'Listado';
      }
    },
    isActive: function () {
      // Verifica si el control navDrawer está activo en el store
      const control = this.mapControlValues('navDrawer');
      return control ? control.active : false;
    }
  },
  methods: {
    openNavAnimation: function () {
      if (this.mode == 4) {
        this.mode = this.lastMode
      }
      const sidenav = document.getElementById("mySidenav");
      if (sidenav) {
        if (this.isMobile) {
          sidenav.style.width = "100vw";
        } else {
          sidenav.style.width = "15em";
        }
      }
    },
    closeNavAnimation: function () {
      const sidenav = document.getElementById("mySidenav");
      if (sidenav) {
        sidenav.style.width = "0";
      }
    },
    closeNav: function () {
      this.selectMapControl('navDrawer', false)
      this.closeNavAnimation();
      // Resetear al menú principal al cerrar, con un pequeño delay para que no se vea el cambio brusco
      setTimeout(() => {
        this.mode = 0;
      }, 300);
    },
    resetAllSelectedButtons: function () {
      this.$store.commit('resetMapToolsSelection')
    },
    onClickSelectTool: function (tool) {
      console.log(`[NavDrawer] Se activa herramienta: ${tool}`)

      // Siempre cerrar el nav drawer al seleccionar una herramienta
      this.closeNav()

      if (tool === 'legends') {
        // Legends is a CONTROL, not a tool
        this.selectMapControl('legends', true)
      } else {
        // Cambiar herramienta seleccionada
        this.selectMapTool(tool, true)
      }
    },
    onClickGoHome: function () {
      this.selectMapControl('navDrawer', false)
      // Lógica de navegación simple por ahora
      if (window.history.length > 1) {
        this.$router.go(-1);
      } else {
        this.$router.push('/inicio/');
      }
    }
  },
  watch: {
    'isActive': function (newValue) {
      if (newValue) {
        this.openNavAnimation();
      } else {
        this.closeNavAnimation();
      }
    }
  }
}
</script>

<style lang="scss" scoped>
.sidenav {
  height: 100%;
  width: 0;
  position: fixed;
  z-index: 1;
  top: 0;
  left: 0;
  background-color: #ffffff;
  overflow-x: hidden;
  transition: 0.5s;
  z-index: 100000000;
}

.sidenav a {
  /*
  padding: 8px 8px 8px 32px;
  text-decoration: none;
  font-size: 25px;
  color: #818181;
  display: block;
  transition: 0.3s;
  */
  text-decoration: none;
  color: #006FB3;
  transition: 0.3s;
}

.sidenav a:hover {
  color: #f7e200;
}

.sidenav .closebtn {
  /*
  position: absorelute;
  top: 0;
  right: 25px;
  font-size: 36px;
  margin-left: 50px;
  */
}

.btn-container {
  display: flex;
  justify-content: space-evenly;

  .btn-secondary {
    justify-content: center;
    width: 5em;
    height: 2em;
  }

  .btn-secondary:hover {
    color: #004B7A;
    background: #f7e200;
    box-shadow: -2px -2px 0.25em gray;
  }
}

.btn-container-no-shadow {
  display: flex;
  flex-direction: column;
  justify-content: space-evenly;
  align-items: center;

  .btn-secondary {
    justify-content: center;
    border: solid 2px #004B7A;
    width: 2em;
    height: 2em;
  }

  .btn-secondary:hover {
    color: #004B7A;
    background: #f7e200;
  }

  .btn-secondary:disabled {
    color: gray;
    background: white;
    border: solid 2px gray;
  }

  .btn-secondary:disabled:hover {
    background: none;
    color: gray;
    opacity: 1;
  }
}

.tab-container {
  background: #f1f1f1;
  width: 100%;
  justify-content: flex-start;

  button {
    min-width: 1em;
  }
}

.btn {
  //padding-top: 0.75em;
}

.tools {
  display: flex;
  flex-direction: column;
  grid-column-gap: 0.25em;
  //grid-row-gap: 0.25em;
}

.btn-secondary {
  border: none;
  display: flex;
  border-radius: 0px;
  font-size: 0.9em;
  align-items: center;
  height: 4em;
  background: transparent;

  p {
    margin-left: 0.5em;
  }
}

.toolSelected {
  color: #004B7A;
  background: black;
}

p {
  margin-top: 0.5em;
}

.fa-lg {
  font-size: 2em;
}

.btnSelected {
  color: white;
  background: #006FB3;
}

.btnTabSelected {
  color: white;
  background: #006FB3;
  box-shadow: -2px -2px 0.25em gray;
}

.btn-tab {
  border-bottom: solid 2px gray;
  width: min-content;
}

.btn-secondary:hover {
  color: #004B7A;
  background: #f7e200;
}

@media screen and (max-width: 960px) {
  .tools {
    grid-template-columns: 1fr 1fr;
  }
}

.place-title {
  display: flex;
  align-items: center;
  font-weight: bold;
  font-size: 1.25em;

  img {
    width: 1.25em;
    height: 1.25em;
  }
}

.place-name {
  //font-size: 1.0625em;
  //color: #006FB3;
}

.place-lat-lon {
  color: #006FB3;
}

span {
  //font-weight: bold;
}

.btn-clean {
  border-radius: 12px;
  -webkit-transition: 200ms ease;
  font-size: 0.75em;
  transition: 200ms ease;
  font-weight: bold;
  padding: 0.3em 0.9em;
  min-width: 8em;
}
</style>
